<template>
  <div class="aroma-report-share">
    <aroma-secondary-nav title="分享报告" fallback="AromaReportDetail" :fallback-query="detailQuery" />
    <main v-if="imageUrl" class="aroma-report-share__content">
      <p>长按图片保存或发送给好友</p>
      <img :src="imageUrl" alt="完整睡眠报告长图" />
    </main>
    <van-empty v-else description="分享图片已失效，请返回重新生成" />
  </div>
</template>

<script>
import AromaSecondaryNav from '@/components/aroma-report/AromaSecondaryNav.vue'
import { clearReportShareUrl, getReportShareUrl } from '@/utils/aroma-report-share'

export default {
  name: 'AromaReportShare',
  components: { AromaSecondaryNav },
  data () { return { imageUrl: getReportShareUrl() } },
  computed: {
    detailQuery () { return { sn: this.$route.query.sn || '', reportId: this.$route.query.reportId || '' } }
  },
  mounted () {
    if (!this.imageUrl) this.returnToDetail()
  },
  beforeDestroy () { clearReportShareUrl() },
  methods: {
    close () {
      clearReportShareUrl()
      this.returnToDetail()
    },
    returnToDetail () {
      const sn = this.$route.query.sn || ''
      const reportId = this.$route.query.reportId || ''
      this.$router.replace({ name: 'AromaReportDetail', query: { sn, reportId } })
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-report-share { min-height: 100%; overflow-x: hidden; background: #eef0f4; }
.aroma-report-share__content { max-width: 520px; margin: 0 auto; padding: 14px 12px calc(24px + env(safe-area-inset-bottom)); box-sizing: border-box; }
.aroma-report-share__content p { margin: 0 0 12px; color: #747c8c; font-size: 13px; text-align: center; }
.aroma-report-share__content img { display: block; width: 100%; height: auto; background: #fff; box-shadow: 0 6px 24px rgba(30,39,68,.12); }
</style>
